import ArgonBox from "components/ArgonBox";
import Kanban from "layouts/applications/kanban/CRMTodo";
import KanbanContainer from "layouts/applications/kanban/V2/KanbanContainer";
import SignInIllustration from "layouts/authentication/sign-in/illustration";
import SignUpIllustration from "layouts/authentication/sign-up/illustration";
import CRM from "layouts/dashboards/crm";
import BusinessCalendar from "layouts/ecommerce/products/new-product/BusinessCalendar";
import EditBusinessEmployees from "layouts/ecommerce/products/new-product/businessEmployees";
import EditBusinessHours from "layouts/ecommerce/products/new-product/businessHours";
import EditBusinessInfo from "layouts/ecommerce/products/new-product/businessInfo";
import EditBusinessServices from "layouts/ecommerce/products/new-product/businessServices";
import Settings from "layouts/pages/account/settings";
import AutoLeadsPage from "layouts/pages/account/settings/AutoLeadsGuide";
import EmailConnectionPage from "layouts/pages/account/settings/SocialGuide";
import PricingPage from "layouts/pages/pricing-page";
import ConnectAccounts from "layouts/pages/sweet-alerts/Connect";
import Onboarding from "layouts/pages/users/new-user/onboarding";
import CRMReport from "layouts/pages/users/reports";

// Argon Dashboard 2 PRO MUI components
import AddBulkLeads from "layouts/pages/users/reports/AddBulkLeads";
import CRMAnswer from "layouts/pages/users/reports/Answer";
import CRMBookings from "layouts/pages/users/reports/Bookings";
import CRMClients from "layouts/pages/users/reports/Clients";
import ComingSoon from "layouts/pages/users/reports/ComingSoonPage";
import CRMFlow from "layouts/pages/users/reports/CRMFlow";
import CMSSocial from "layouts/pages/users/reports/SocialPost";
import WorkflowSelector from "layouts/pages/users/reports/WorkFlowSelector";

import PaymentGuidePage from "./layouts/pages/account/settings/PaymentGuide";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-shop" />,
    noCollapse: true,
    component: <CRM />,
  },
  {
    type: "collapse",
    name: "Calendario",
    key: "events",
    route: "events",
    icon: (
      <ArgonBox component="i" color="success" fontSize="14px" className="ni ni-calendar-grid-58" />
    ),
    noCollapse: true,
    component: <BusinessCalendar />,
  },
  { type: "title", title: "CRM", key: "title-pages" },
  {
    type: "collapse",
    name: "Clienti e Relazioni",
    key: "Manage Leads",
    icon: <ArgonBox component="i" color="warning" fontSize="14px" className="ni ni-ungroup" />,
    collapse: [
      {
        name: "Leads",
        key: "leadboard",
        route: "/crm/leads",
        component: <CRMReport />,
        icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-shop" />,
      },
      {
        name: "Pipeline di vendita",
        key: "Todo",
        route: "/crm/todo",
        component: <KanbanContainer />,
        icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-shop" />,
      },
      {
        name: "Clienti",
        key: "clients",
        route: "/crm/clients",
        component: <CRMClients />,
        icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-shop" />,
      },
      {
        name: "Messaggi",
        key: "answer",
        route: "/crm/answer",
        component: <CRMAnswer />,
        icon: <ArgonBox component="h" color="primary" fontSize="14px" className="ni ni-shop" />,
      },
      {
        name: "Automazioni",
        key: "workflow",
        route: "/crm/workflow",
        component: <CRMFlow />,
        icon: <ArgonBox component="h" color="secondary" fontSize="14px" className="ni ni-shop" />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Vendita & Contenuti ",
    key: "Sales&Content",
    icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-ungroup" />,
    collapse: [
      {
        name: "Social Media",
        key: "social",
        route: "/cms/social",
        component: <CMSSocial />,
        icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-shop" />,
      },
      {
        name: "Appuntamenti",
        key: "booking",
        route: "/crm/bookings",
        component: <CRMBookings />,
        icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-shop" />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Coming Soon",
    key: "comingSoon",
    icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-ungroup" />,
    collapse: [
      {
        name: "Website Builder",
        key: "comingsoon",
        route: "/comingsoon",
        component: <ComingSoon />,
      },
      {
        name: "Google My Business",
        key: "comingsoon",
        route: "/comingsoon",
        component: <ComingSoon />,
      },
      {
        name: "Pubblicità",
        key: "comingsoon",
        route: "/comingsoon",
        component: <ComingSoon />,
      },
      {
        name: "Reporting",
        key: "comingsoon",
        route: "/comingsoon",
        component: <ComingSoon />,
      },
      {
        name: "Reputazione",
        key: "comingsoon",
        route: "/comingsoon",
        component: <ComingSoon />,
      },
      {
        name: "SEO Tools",
        key: "comingsoon",
        route: "/comingsoon",
        component: <ComingSoon />,
      },
      {
        name: "Integrazione eCommerce",
        key: "comingsoon",
        route: "/comingsoon",
        component: <ComingSoon />,
      },
    ],
  },
  {
    type: "hidden",
    name: "Authentication",
    key: "authentication",
    icon: <ArgonBox component="i" color="error" fontSize="14px" className="ni ni-single-copy-04" />,
    collapse: [
      {
        name: "Sign In",
        key: "sign-in",
        collapse: [
          {
            name: "Illustration",
            key: "illustration",
            route: "/signin",
            component: <SignInIllustration />,
          },
        ],
      },
      {
        name: "Sign Up",
        key: "sign-up",
        collapse: [
          {
            name: "Illustration",
            key: "illustration",
            route: "/signup",
            component: <SignUpIllustration />,
          },
        ],
      },
      {
        name: "Account",
        key: "account",
        collapse: [
          {
            name: "Account",
            key: "account",
            route: "/account",
            component: <Settings />,
          },
        ],
      },
    ],
  },
  {
    type: "hidden",
    name: "onboarding",
    key: "onboarding",
    icon: <ArgonBox component="i" color="error" fontSize="14px" className="ni ni-single-copy-04" />,
    collapse: [
      {
        name: "onboarding",
        key: "sign-in",
        route: "onboarding",
        component: <Onboarding />,
      },
    ],
  },
  { type: "divider", key: "divider-1" },
  { type: "title", title: "INFO", key: "title-docs" },
  {
    type: "collapse",
    name: "Profilo Azienda",
    key: "websitePage",
    icon: <ArgonBox component="i" color="inherit" fontSize="14px" className="ni ni-spaceship" />,
    collapse: [
      {
        name: "Informazioni Azienda",
        key: "info",
        route: "business/information",
        component: <EditBusinessInfo />,
      },
      {
        name: "Gestisci team",
        key: "employees",
        route: "business/employees",
        component: <EditBusinessEmployees />,
      },
      {
        name: "Servizi azienda",
        key: "services",
        route: "business/services",
        component: <EditBusinessServices />,
      },
      {
        name: "Orario Lavorativo",
        key: "businessHours",
        route: "business/businesshours",
        component: <EditBusinessHours />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Centro Connessioni",
    key: "connect",
    route: "/connect",
    icon: (
      <ArgonBox component="d" color="success" fontSize="14px" className="ni ni-single-copy-04" />
    ),
    component: <ConnectAccounts />,
    noCollapse: true,
  },
  {
    type: "hidden",
    name: "Add Bulk Leads",
    key: "bulkleads",
    icon: <ArgonBox component="i" color="error" fontSize="14px" className="ni ni-single-copy-04" />,
    collapse: [
      {
        name: "add Bulk Leads",
        key: "bulkleads",
        route: "crm/addBulkLeads",
        component: <AddBulkLeads />,
      },
    ],
  },
  {
    type: "hidden",
    name: "subscription",
    key: "subscription",
    route: "/subscription",
    icon: (
      <ArgonBox component="d" color="success" fontSize="14px" className="ni ni-single-copy-04" />
    ),
    component: <PricingPage />,
    noCollapse: true,
  },
  {
    type: "hidden",
    name: "Add Workflow From Template",
    key: "crm",
    icon: <ArgonBox component="i" color="error" fontSize="14px" className="ni ni-single-copy-04" />,
    collapse: [
      {
        name: "add Workflow From Template",
        key: "crmtemplate",
        route: "crm/template",
        component: <WorkflowSelector />,
      },
    ],
  },
  { type: "divider", key: "divider-2" },
  { type: "title", title: "Docs", key: "docs-docs" },
  {
    type: "collapse",
    name: "Guida",
    key: "guides",
    icon: <ArgonBox component="i" color="secondary" fontSize="14px" className="ni ni-spaceship" />,
    collapse: [
      {
        name: "Configura pagamenti",
        key: "paymentMethods",
        route: "guides/payments",
        icon: (
          <ArgonBox component="i" color="secondary" fontSize="14px" className="ni ni-payment" />
        ),
        component: <PaymentGuidePage />,
      },
      {
        name: "Configura email",
        key: "email",
        route: "guides/social",
        icon: (
          <ArgonBox component="i" color="secondary" fontSize="14px" className="ni ni-payment" />
        ),
        component: <EmailConnectionPage />,
      },
      {
        name: "Guida ai leads automatici",
        key: "leads",
        route: "guides/leads",
        icon: (
          <ArgonBox component="i" color="secondary" fontSize="14px" className="ni ni-payment" />
        ),
        component: <AutoLeadsPage />,
      },
    ],
  },
];

export default routes;
